var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReducedTillageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 77,
    viewBox: "0 0 82 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44531 38.261C2.44531 48.4085 6.50731 58.1403 13.7377 65.3156C20.9681 72.491 30.7746 76.522 41 76.522C51.2253 76.522 61.0318 72.491 68.2622 65.3156C75.4926 58.1403 79.5546 48.4085 79.5546 38.261C79.5546 28.1136 75.4926 18.3817 68.2622 11.2064C61.0318 4.03106 51.2253 0 41 0C30.7746 0 20.9681 4.03106 13.7377 11.2064C6.50731 18.3817 2.44531 28.1136 2.44531 38.261Z",
    fill: "#F7F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6816 54.9849C76.9337 52.4253 77.8923 49.7343 78.5394 46.9625L77.4474 46.136C73.7429 43.4703 69.2884 42.0264 64.7125 42.008C60.1367 41.9896 55.6705 43.3978 51.9444 46.0337L39.8672 54.9849H75.6816Z",
    fill: "#F7CA50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5394 46.9625L77.4474 46.136C73.7429 43.4703 69.2884 42.0264 64.7125 42.008C60.1367 41.9896 55.6705 43.3978 51.9444 46.0337L39.8672 54.9849",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10029 42.577L3.14844 45.5613C3.78268 48.8281 4.84657 51.9981 6.31281 54.9898H59.818L42.8761 42.4278C32.6437 34.8435 17.2459 34.9057 7.10029 42.577Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.818 54.985L42.8761 42.4278C32.6437 34.8435 17.2459 34.9057 7.10029 42.577L3.14844 45.5614",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6859 54.9863H6.32031",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5938 54.9863H81.0034",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 54.9863H3.40967",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8828 10.9452V9.44727",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.482 13.5774L44.4141 12.5176",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8297 19.9336H41.3203",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.482 26.2891L44.4141 27.3489",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7969 13.5774L59.8639 12.5176",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4453 19.9336H62.9557",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7969 26.2891L59.8639 27.3489",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8828 28.9238V30.4217",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8359 19.9346C44.8359 21.7888 45.5782 23.567 46.8993 24.8782C48.2205 26.1893 50.0124 26.9258 51.8808 26.9258C53.7493 26.9258 55.5412 26.1893 56.8623 24.8782C58.1835 23.567 58.9257 21.7888 58.9257 19.9346C58.9257 18.0804 58.1835 16.3022 56.8623 14.991C55.5412 13.6799 53.7493 12.9434 51.8808 12.9434C50.0124 12.9434 48.2205 13.6799 46.8993 14.991C45.5782 16.3022 44.8359 18.0804 44.8359 19.9346Z",
    fill: "white",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0755 34.7917C27.0755 29.9029 25.7608 20.6677 22.2147 16.3518C22.1033 16.2191 21.9638 16.1123 21.8061 16.039C21.6485 15.9657 21.4765 15.9277 21.3024 15.9277C21.1283 15.9277 20.9563 15.9657 20.7987 16.039C20.641 16.1123 20.5015 16.2191 20.3901 16.3518C16.845 20.6667 15.5312 29.8981 15.5312 34.7831C15.5312 42.113 18.4894 48.7752 21.3029 48.7752C24.1164 48.7752 27.0755 42.1177 27.0755 34.7917Z",
    fill: "#F7CA50",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2969 54.9839V32.3066V54.9839Z",
    fill: "#F7CA50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2969 54.9839V32.3066",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2969 40.899L24.1827 38.0352L21.2969 40.899Z",
    fill: "#F7CA50"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2969 40.899L24.1827 38.0352",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3034 37.3199L19.5 35.5293L21.3034 37.3199Z",
    fill: "#F7CA50"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3034 37.3199L19.5 35.5293",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0042 39.8045C40.0042 36.14 39.0191 29.2186 36.3617 25.9836C36.2782 25.8842 36.1736 25.8042 36.0554 25.7494C35.9372 25.6945 35.8084 25.666 35.6779 25.666C35.5474 25.666 35.4185 25.6945 35.3003 25.7494C35.1822 25.8042 35.0776 25.8842 34.994 25.9836C32.3366 29.2177 31.3516 36.1362 31.3516 39.7978C31.3516 45.2921 33.5685 50.2851 35.6774 50.2851C37.7863 50.2851 40.0042 45.2911 40.0042 39.8045Z",
    fill: "#F7CA50",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6719 54.9857V37.9375V54.9857Z",
    fill: "#F7CA50"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6719 54.9857V37.9375",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6719 44.3769L37.8348 42.2305L35.6719 44.3769Z",
    fill: "#F7CA50"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6719 44.3769L37.8348 42.2305",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6804 41.6936L34.3281 40.3516L35.6804 41.6936Z",
    fill: "#F7CA50"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6804 41.6936L34.3281 40.3516",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2206 54.9863H5.78125C8.96238 61.5783 13.9572 67.1432 20.1891 71.0385C26.421 74.9339 33.6359 77.0008 41.0009 77.0008C48.366 77.0008 55.5809 74.9339 61.8128 71.0385C68.0447 67.1432 73.0395 61.5783 76.2206 54.9863Z",
    fill: "#F7CA50"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.662 54.9863H5.33594",
    stroke: "#0E2032",
    strokeWidth: 0.732919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducedTillageIcon);
export default __webpack_public_path__ + "static/media/reducedTillageIcon.7f2cb506917f369f52aa843c20b2d0b4.svg";
export { ForwardRef as ReactComponent };